import { paymentTypes } from '@/features/ui/Steps/Payment/lib/constants';

import { ExternalInformerConfig, PredefinedInformerType } from '@/shared/ui/Informer/types';

import { UserServicePaymentType } from '@/api/types';

export const predefinedInformers: Partial<Record<PredefinedInformerType, ExternalInformerConfig>> = {
  [PredefinedInformerType.CONTACT_CENTER]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Контактний центр',
      color: 'blue',
    },
    text: {
      text: "Зверніться до нашого контактного центру Єдиного реєстру зброї, за номером телефону <a href='tel:+380 (044) 350-53-07'>+380 (044) 350-53-07</a>. Наші спеціалісти з радістю відповідатимуть на ваші запитання та нададуть допомогу в усіх питаннях, пов&apos;язаних із реєстрацією зброї.",
    },
  },
  [PredefinedInformerType.CLUE]: {
    borderColor: 'blue',
    icon: {
      name: 'info',
      color: 'blue',
    },
    header: {
      text: 'Корисна інформація',
      color: 'blue',
    },
    linkKey: 'serviceInformer.policeAdresses',
    linkText: 'Місце розташування органів (підзрозділів) поліції',
  },
  [PredefinedInformerType.VALIDITY_PERIOD_VIOLATION]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Увага!',
      color: 'red',
    },
    text: {
      text: `У разі порушення строків реєстрації, перереєстрації
          (продовженні строку дії дозволу на зберігання, носіння) зброї,
          основних частин зброї, пристроїв фізична особа особисто звертається
          до органу (підрозділу) поліції за місцем проживання.`,
    },
  },
  [PredefinedInformerType.PLACE_OF_RESIDENCE]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Увага!',
      color: 'red',
    },
    text: {
      text: `Отримати витяг з реєстру територіальних громад про
          задеклароване / зареєстроване місце проживання (перебування)
          можливо за посиланням`,
    },
    linkKey: 'serviceInformer.vityagTeritorialnoyiGromadi',
    linkText: 'Інструкція з отримання витягу',
  },
  [PredefinedInformerType.TECHNICAL_CONDITION_DETAILS]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Увага!',
      color: 'blue',
    },
    text: {
      text: `Ви можете отримати послугу з огляду технічного стану та
          відстрілу нарізної (комбінованої) зброї або пристроїв, призначених
          для відстрілу патронів, споряджених гумовими кулями в будь-якій
          установі Експертноі служби МВС на території України в будь-який
          робочий день з 9-00 до 18-00.`,
    },
    linkKey: 'serviceInformer.policeDutyUnits',
    linkText: 'Чергові частини НДЕКЦ МВС',
  },
  [PredefinedInformerType.TECHNICAL_CONDITION_DOCUMENT_DATA]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Увага!',
      color: 'red',
    },
    text: {
      text: `Документом є:
            <ul>
              <li>Довідка про огляд технічного стану і відстріл нарізної зброї, її основних частин, пристрою;</li>
              <li>
                Довідка про огляд технічного стану мисливської гладкоствольної зброї, її основних частин, холодної,
                охолощеної зброї, газових пістолетів (револьверів).
              </li>
            </ul>
          `,
    },
  },
  [PredefinedInformerType.PAYMENT_DETAILS]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'red',
    },
    text: {
      text: 'Послуга є платною. Ви можете оплатити її онлайн в процесі замовлення, або додати документ про її сплату на рахунок відповідного Головного управління Національної поліції.',
    },
    linkKey: 'serviceInformer.paymentDetails',
    linkText: 'Інформація про реквізити платежів',
  },
  [PredefinedInformerType.HAS_ACTIVE_REQUEST]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'red',
    },
    text: {
      text: 'Повторний запит можливо відправити тільки після того, як буде опрацьовано поточний',
    },
  },
  [PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_ELECTRONIC]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Виникли проблеми з заповненням запиту?',
      color: 'blue',
    },
    text: {
      text: 'Ознайомтесь з покроковою відеоінструкцією',
    },
    linkKey: 'serviceInformer.criminalRecordExtractDigitalVideoInstruction',
    linkText: 'Відеоінструкція',
    formValueConditions: {
      extractFormType: 'ELECTRONIC',
    },
  },
  [PredefinedInformerType.CRIMINAL_RECORD_EXTRACT_VIDEO_PAPER]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Виникли проблеми з заповненням запиту?',
      color: 'blue',
    },
    text: {
      text: 'Ознайомтесь з покроковою відеоінструкцією',
    },
    linkKey: 'serviceInformer.criminalRecordExtractPaperVideoInstruction',
    linkText: 'Відеоінструкція',
    formValueConditions: {
      extractFormType: 'PAPER',
    },
  },
  [PredefinedInformerType.QRCODE_DIIA]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Для чого сканується цей QR?',
      color: 'red',
    },
    text: {
      text: 'Сканування QR коду на цьому етапі потрібно для ідентифікації вашої особи',
    },
  },
  [PredefinedInformerType.QRCODE_DIIA_NEXT]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Для чого сканується цей QR вдруге?',
      color: 'red',
    },
    text: {
      text: 'Сканування QR коду на цьому етапі потрібно для безпосереднього підпису вашої заяви',
    },
  },
  [PredefinedInformerType.PAYMENT_OFFLINE]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'blue',
    },
    text: {
      text: 'Платіжний документ (платіжне доручення, квитанція) з відміткою банку, відділення поштового зв’язку або коду проведеної операції про внесення коштів за надання відповідної платної послуги',
    },
    formValueConditions: {
      paymentType: paymentTypes[UserServicePaymentType.OFFLINE],
    },
  },
  [PredefinedInformerType.PAYMENT_ONLINE]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'blue',
    },
    text: {
      text: 'Після натиснення кнопки “Оплатити” вас буде перенаправлено на сайт оплати. Слідкуйте підказкам для оплати послуги та по завершенню натисніть на кнопку “Повернутися на сайт”',
    },
    formValueConditions: {
      paymentType: paymentTypes[UserServicePaymentType.ONLINE],
    },
  },
  [PredefinedInformerType.PERSON_STATUS]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'blue',
    },
    text: {
      text: 'Статус особи заповнюється з долученням відповідної підтверджуючої довідку з місця служби (роботи) про наявність спеціального статусу для отримання послуги щодо придбання, зберігання, носіння або продовження такого права на пристрої вітчизняного виробництва для відстрілу патронів, споряджених гумовими чи аналогічними за своїми властивостями метальними снарядами несмертельної дії.”',
    },
  },
  [PredefinedInformerType.LEARNING_DOCUMENT]: {
    borderColor: 'blue',
    icon: {
      name: 'attention',
      color: 'blue',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'blue',
    },
    text: {
      text: 'Поліцейські, працівники інших державних правоохоронних органів, державних органів спеціального призначення з правоохоронними функціями, військовослужбовці Збройних Сил України, інших військових формувань, крім військовослужбовців, які проходять строкову військову службу подають довідку про вивчення матеріальної частини зброї або копії відповідного документа про закріплення вогнепальної зброї',
    },
  },
  [PredefinedInformerType.ELECTRONIC_EXTRACT_DISABLED]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'red',
    },
    text: {
      text: 'Тимчасово недоступна опція для замовлення електронної форми витягу.',
    },
    formValueConditions: {
      isElectronicExtractDisabled: true,
    },
  },
  [PredefinedInformerType.PAPER_EXTRACT_DISABLED]: {
    borderColor: 'dark-yellow',
    icon: {
      name: 'attention',
      color: 'red',
    },
    header: {
      text: 'Зверніть увагу!',
      color: 'red',
    },
    text: {
      text: 'Тимчасово недоступна опція для замовлення паперової форми витягу.',
    },
    formValueConditions: {
      isPaperExtractDisabled: true,
    },
  },
};
